export default __webpack_public_path__ + "static/media/step1.95db9c47.mp4";